import React from "react";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import "./Marketing.scss";
import { last } from "ramda";

const CustomIntlTelInput = ({
  value,
  css,
  preferredCountries,
  form: { setFieldValue, setFieldTouched, errors, touched },
  field: { name, validateField },
  ...props
}) => {
  return (
    <div>
      <IntlTelInput
        validate={validateField}
        fieldName={name}
        defaultValue={value}
        onPhoneNumberChange={(isValid, value, countryCode) => {
          if (isNaN(last(value))) {
            setFieldTouched(name, true, true);
          }
          if (isValid) {
            setFieldTouched(name, true, true);
            value = window.intlTelInputUtils.formatNumber(
              value,
              countryCode.iso2
            );
            setFieldValue(name, value);
          }
          setFieldValue(name, value);
        }}
        onPhoneNumberBlur={() => {
          setFieldTouched(name, true, true);
        }}
        // preferredCountries={[`${preferredCountries}`]}
        preferredCountries={preferredCountries}
        css={["intl-tel-input", `${css}`]}
        format={true}
      />

      {errors[name] && touched[name] ? (
        <div className="validation-message">{errors[name]}</div>
      ) : null}
    </div>
  );
};

export default CustomIntlTelInput;
